import {
  faLocationDot,
  faPersonDigging,
} from "@fortawesome/free-solid-svg-icons";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import videoThumbnail from "../assets/images/video-thubnail.jpg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-video.css";
import lgVideo from "lightgallery/plugins/video";
import ScheduleMeeting from "../components/common/schedule-meeting";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import buymoduleService from "../services/BuyModule-service/buy-module-service";
import { handleErrors } from "../utils/errorHandler";
import { useUser } from "../components/context/UserContext";
import { useBuyWishlist } from "../components/context/BuyContext";
import { useLoginModal } from "../components/context/LoginPopUpContext";
import BuyMetaDetails from "../components/buy-components/BuyMetaDetails";
import BuyOverview from "../components/buy-components/BuyOverview";
import BuyDetails from "../components/buy-components/BuyDetails";
import BuyDocumentation from "../components/buy-components/BuyDocumentation";
import BuyAmenities from "../components/buy-components/BuyAmenities";
import BuyNearby from "../components/buy-components/BuyNearby";
import BuyLocation from "../components/buy-components/BuyLocation";
import BuyPriceBlock from "../components/buy-components/BuyPriceBlock";
import NoFloorPlan from "../assets/images/floor-plan-not-available.png";
import { getPropertyImageAlt } from "../utils/propertyImageAlt";

const BuyPropertyDetail = ({ propertyId }) => {
  const [propData, setPropData] = useState([]);
  const [propertyNearby, setPropertyNearBy] = useState([]);
  const [PropertyAmenities, setPropertyAmenities] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [bhkdata, setBhkData] = useState([]);
  const [bhkType, setBhkType] = useState([]);
  const [documentationData, setDocumentationData] = useState({});
  const [schelduleData, setSchelduleData] = useState({});
  const contentRef = useRef(null);
  const [visibleReadmore, SetVisibleReadmore] = useState(false);
  const [isReadMore, setIsReadMore] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const { user, isCheckingAuth } = useUser();
  const { wishlist, addToBuyWishlist, removeFromBuyWishlist } =
    useBuyWishlist();
  const flatId = propData?.propertyDTO?.id;
  const propertyGuid = propData?.propertyDTO?.propertyGuid;

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeBhk, setActiveBhk] = useState(null);
  const [activeFloorDetail, setActiveFloorDetail] = useState(null);

  const swiperRef = useRef(null);

  const [id, setId] = useState();
  const [slug, setSlug] = useState();
  const location = useParams();

  const { openLogin, setVisitPageCount, visitPageCount } = useLoginModal();
  useEffect(() => {
    if (!isCheckingAuth && !user.isAuthenticated) {
      setVisitPageCount(visitPageCount + 1);
      openLogin();
    }
  }, [isCheckingAuth, user.isAuthenticated]);

  const exploreNearBy = {
    BusinessCentres: "Business Centres",
    Temples: "Temples",
    Eatouts: "Eatouts",
    Shopping: "Shopping",
    Hospitals: "Hospitals",
    NearestProperties: "Nearest Properties",
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 767);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const handleWishlist = async (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (!user.isAuthenticated) {
      openLogin({ actionName: "addtoWishList", FlatId: propertyGuid });
      return;
    }

    try {
      if (isWishlisted) {
        const wishListId = wishlist?.find(
          (item) => item.propertyId === flatId,
        )?.id;
        await removeFromBuyWishlist(wishListId);
        setIsWishlisted(false);
      } else {
        await addToBuyWishlist(propertyGuid);
        setIsWishlisted(true);
      }
    } catch (error) {
      console.error("Error during wishlist operation:", error);
      toast.error("An error occurred. Please try again later.");
    }
  };

  useEffect(() => {
    if (flatId) {
      setIsWishlisted(wishlist?.some((item) => item.propertyId === flatId));
    }
  }, [wishlist, flatId]);

  useEffect(() => {
    const pathname = location.slug;
    const lastSegment = pathname.split("-");
    const extractId = lastSegment.pop();
    const extractUrl = lastSegment.join("-");
    setId(extractId);
    setSlug(extractUrl);
  }, [location]);

  useEffect(() => {
    if (!id || !slug) return;
    const getPropertyDetail = async () => {
      setLoading(true);
      try {
        const response = await buymoduleService.propertyDetails(slug, id);
        const result = response.data.result;
        setPropData(result);
        setPropertyNearBy(result?.nearByDto);
        setPropertyAmenities(result?.amenitiesDTOs);
        setGalleryImages(result?.galleryDTOs);
        setSchelduleData(result?._Property);
        setDocumentationData(result?.documentationVerificationsDTO);
        setBhkData(result?.pricingAndPlainingDtos || []);

        const types =
          result?.pricingAndPlainingDtos?.map((item) => item.type) || [];
        setBhkType(types);

        const firstBhk = result?.pricingAndPlainingDtos?.[0];
        setActiveBhk(firstBhk?.type || null);

        const firstDetail = firstBhk?.fullDetails?.[0] || null;
        setActiveFloorDetail(firstDetail);
      } catch (error) {
        const errorMessage = handleErrors(error);
        setErrors(errorMessage);
      } finally {
        setLoading(false);
      }
    };
    getPropertyDetail();
  }, [id, slug]);

  /* ------------------------------------------------------------------
   * Shared selection handlers.
   * Every copy of <BhkFloorTabs /> — in Property Details, in Floor Plan,
   * anywhere else — calls these, so all sections stay in sync.
   * ------------------------------------------------------------------ */
  const handleBhkChange = (item) => {
    setActiveBhk(item.type);
    setActiveFloorDetail(item.fullDetails?.[0] || null);
    swiperRef.current?.slideTo(0);
  };

  const handleFloorChange = (detail, idx) => {
    setActiveFloorDetail(detail);
    swiperRef.current?.slideTo(idx);
  };

  const activeBhkItem = useMemo(
    () => bhkdata.find((b) => b.type === activeBhk),
    [bhkdata, activeBhk],
  );

  const activeFloorList = useMemo(
    () => activeBhkItem?.fullDetails || [],
    [activeBhkItem],
  );

  /* Stable identity — a new array here re-inits LightGallery every render */
  const floorGalleryItems = useMemo(
    () =>
      activeFloorList.map((d) => ({
        src: d.floorPlanUrl || NoFloorPlan,
        thumb: d.floorPlanUrl || NoFloorPlan,
        subHtml: "",
      })),
    [activeFloorList],
  );

  const propertyVideos = galleryImages
    .map((item, index) => (item.fileType === "Video" ? { item, index } : null))
    .filter((entry) => entry !== null);

  let today = new Date();
  let maxDate = new Date();
  maxDate.setDate(today.getDate() + 10);

  const formatDatetoMonth = (date) => {
    date = new Date(date);
    const formatteddDate = date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
    return formatteddDate;
  };

  const formatAmount = (amount) => {
    if (amount < 1000) return amount.toString();
    const [integer, decimal] = amount.toString().split(".");
    let lastThree = integer.slice(-3);
    let otherNumbers = integer.slice(0, -3);
    if (otherNumbers !== "") {
      lastThree = "," + lastThree;
    }
    const formatted =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return decimal ? `${formatted}.${decimal}` : formatted;
  };

  const getFloorLabel = (floor) => {
    if (floor === null || floor === undefined) return "Floor";
    if (floor === 0) return "Ground Floor";
    if (floor === 1) return "1st Floor";
    if (floor === 2) return "2nd Floor";
    if (floor === 3) return "3rd Floor";
    return `${floor}th Floor`;
  };

  useEffect(() => {
    const overview = contentRef.current;
    if (overview && overview.scrollHeight > overview.clientHeight) {
      SetVisibleReadmore(true);
    }
  }, [propData?.propertyDTO?.aboutProperty]);

  const getGalleryImageAlt = (imageIndex) =>
    getPropertyImageAlt({
      imageIndex,
      bhkType: activeBhk || propData?.propertyDTO?.bhkType,
      furnished: activeFloorDetail?.furnishingStatus,
      location: propData?.propertyDTO?.propertyLocation,
      city: propData?.propertyDTO?.city,
      listingType: "buy",
    });

  const galleryItems =
    galleryImages.length > 0
      ? galleryImages.map((item, index) => ({
          src: item.fileLink,
          thumb: item.fileLink,
          type: item.fileType,
          alt: getGalleryImageAlt(index),
        }))
      : [];

  const galleryconfig = useMemo(
    () =>
      galleryImages.map((item) => {
        if (item.fileType === "Video") {
          return {
            thumb: item.fileLink,
            subHtml: item.fileAlt,
            disableZoom: true,
            video: {
              source: [{ src: item.fileLink, type: "video/mp4" }],
              attributes: { controls: true, preload: "none" },
            },
          };
        }
        return {
          src: item.fileLink,
          thumb: item.fileLink,
          subHtml: item.fileAlt,
        };
      }),
    [galleryImages],
  );

  const lightGallery = useRef(null);
  const onInit = (detail) => {
    lightGallery.current = detail.instance;
  };

  const floorMap =
    bhkdata.length > 0
      ? bhkdata.map((item) => ({
          bhk: item.type || "",
          src: item.floorPlanUrl,
          thumb: item.floorPlanUrl,
          sqft: item.carpetArea,
          price: item.priceRange,
        }))
      : [];

  const lightfloorGallery = useRef(null);
  const floorOnInit = (details) => {
    lightfloorGallery.current = details.instance;
  };

  /* Never call openGallery with an index the instance doesn't have */
  const openMainGallery = (idx) => {
    if (!lightGallery.current) return;
    if (idx < 0 || idx >= galleryconfig.length) return;
    lightGallery.current.openGallery(idx);
  };

  const openFloorGallery = (idx) => {
    if (!lightfloorGallery.current) return;
    if (idx < 0 || idx >= floorGalleryItems.length) return;
    lightfloorGallery.current.openGallery(idx);
  };

  const scrollToSchedule = () => {
    const offset = 1020;
    window.scrollTo({
      top: document.documentElement.scrollHeight - offset,
      behavior: "smooth",
    });
  };

  const formatKeyName = (key) => {
    return key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  };

  /* Brochure button is used in the desktop and the mobile row */
  const brochureButton = (
    <a
      className="floor-download-btn btn btn-primary"
      href={propData?.propertyDTO?.brochure}
      download
      target="_blank"
      rel="noopener noreferrer"
    >
      <svg
        width="11"
        height="16"
        viewBox="0 0 11 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 14.5H10H1ZM5.5 1V11.5V1ZM5.5 11.5L9.25 7.75L5.5 11.5ZM5.5 11.5L1.75 7.75L5.5 11.5Z"
          fill="white"
        />
        <path
          d="M1 14.5H10M5.5 1V11.5M5.5 11.5L9.25 7.75M5.5 11.5L1.75 7.75"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>{" "}
      Download Brochure
    </a>
  );

  const areaAndPriceRow = activeBhkItem ? (
    <div className="bhk-details">
      <p>
        {activeFloorDetail?.buildUpArea ??
          activeBhkItem.fullDetails?.[0]?.buildUpArea}{" "}
        sq.ft.
      </p>
      <span>
        {activeFloorDetail?.priceRange ??
          activeBhkItem.fullDetails?.[0]?.priceRange}
      </span>
    </div>
  ) : null;

  /* ------------------------------------------------------------------
   * Floor Plan block — no tabs of its own any more.
   * It is passed as children to <BuyDetails /> so it renders directly
   * under the Property Details grid, sharing one set of tabs.
   * ------------------------------------------------------------------ */
  const floorPlanBlock =
    propData?.propertyDTO?.propertyType !== "Plot/Land" ? (
      <div className="property-floor-plan">
        {/* <div className="first-head d-flex justify-content-between align-items-center">
          <h3>Floor Plan</h3>
        </div> */}

        {/* Desktop — area + brochure */}
        <div className="second-head d-flex justify-content-between d-none-mobile-top">
          {areaAndPriceRow}
          {brochureButton}
        </div>

        {/* <div className="floor-head-button d-flex justify-content-end"></div> */}

        {/* Floor image swiper */}
        <div className="floor-img-block">
          <LightGallery
            plugins={[lgZoom]}
            dynamic={true}
            dynamicEl={floorGalleryItems}
            elementClassNames="floorMap-container"
            onInit={floorOnInit}
          >
            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => {
                const newDetail = activeFloorList[swiper.activeIndex];
                if (newDetail) setActiveFloorDetail(newDetail);
              }}
              modules={[Pagination]}
              slidesPerView={1}
              pagination={{ clickable: true }}
              speed={1500}
            >
              {activeFloorList.map((detail, idx) => (
                <SwiperSlide
                  key={detail.id ?? idx}
                  onClick={() => openFloorGallery(idx)}
                  style={{ cursor: "pointer" }}
                >
                  <InnerImageZoom
                    src={detail.floorPlanUrl || NoFloorPlan}
                    zoomType="hover"
                    zoomScale={1.5}
                    moveType="pan"
                    hoverDelay={1000}
                    fadeDuration={200}
                    zoomPreload={true}
                    hideHint={true}
                    fullscreenOnMobile={true}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </LightGallery>
        </div>

        {/* Mobile — area + brochure */}
        <div className="second-head d-none-desktop-bottom">
          {areaAndPriceRow}
          {brochureButton}
        </div>
      </div>
    ) : null;

  if (loading) {
    return (
      <div className="loading-spinner w-100 h-100vh d-flex justify-content-center align-items-center py-5 my-5">
        <ProgressSpinner
          style={{ width: "50px", height: "50px" }}
          strokeWidth="3"
          fill="var(--surface-ground)"
          animationDuration=".5s"
        />
      </div>
    );
  }

  return (
    <>
      <section
        className=" buy-model custom-breadcrumb pt-3"
        style={{ backgroundColor: "#f1f5f8" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <ul className="bread-crumb-list">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/buy">Buy</a>
                </li>
                <li>
                  <a href="../list">
                    {propData?.propertyDTO?.city
                      ? propData.propertyDTO.city
                      : "Bangalore"}
                  </a>
                </li>
                <li>
                  <a
                    href={`/buy/list?search=${propData?.propertyDTO?.propertyLocation}`}
                    target="_blank"
                  >
                    {propData?.propertyDTO?.propertyLocation
                      ? propData.propertyDTO.propertyLocation
                      : "-"}
                  </a>
                </li>
                <li>
                  <a href={"#"}>
                    {propData?.propertyDTO?.propertyListingName
                      ? propData.propertyDTO.propertyListingName
                      : "-"}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="residence-banner buy-detail-banner">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="residence-title-wrap">
                <div className="left-col">
                  <div className="title-wrap">
                    <div className="wrap mobile-head-wrap">
                      <h1>
                        {propData?.propertyDTO?.propertyListingName
                          ? propData.propertyDTO.propertyListingName
                          : "-"}
                      </h1>
                      {propData?.propertyDTO?.reraApproved && (
                        <>
                          <span className="dot"></span>
                          <span className="badge bg-white approved-badge">
                            <svg
                              width="20"
                              height="19"
                              viewBox="0 0 20 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="pe-1"
                            >
                              <path
                                d="M19.555 8.3033L18.195 6.80267C17.935 6.51774 17.725 5.98588 17.725 5.60597V3.99138C17.725 2.98463 16.855 2.15833 15.795 2.15833H14.095C13.705 2.15833 13.135 1.95888 12.835 1.71195L11.255 0.42027C10.565 -0.14009 9.43504 -0.14009 8.73504 0.42027L7.165 1.72144C6.865 1.95888 6.295 2.15833 5.905 2.15833H4.175C3.115 2.15833 2.245 2.98463 2.245 3.99138V5.61547C2.245 5.98588 2.035 6.51774 1.785 6.80267L0.435 8.3128C-0.145 8.96814 -0.145 10.0319 0.435 10.6872L1.785 12.1973C2.035 12.4823 2.245 13.0141 2.245 13.3845V15.0086C2.245 16.0154 3.115 16.8417 4.175 16.8417H5.905C6.295 16.8417 6.865 17.0411 7.165 17.2881L8.74504 18.5797C9.43504 19.1401 10.565 19.1401 11.265 18.5797L12.845 17.2881C13.145 17.0411 13.705 16.8417 14.105 16.8417H15.805C16.865 16.8417 17.735 16.0154 17.735 15.0086V13.394C17.735 13.0236 17.945 12.4823 18.205 12.1973L19.565 10.6967C20.145 10.0414 20.145 8.95864 19.555 8.3033ZM14.155 7.70495L9.32504 12.2923C9.18504 12.4253 8.99504 12.5013 8.79504 12.5013C8.59504 12.5013 8.40504 12.4253 8.26504 12.2923L5.845 9.99388C5.555 9.71845 5.555 9.26256 5.845 8.98713C6.135 8.7117 6.615 8.7117 6.905 8.98713L8.79504 10.7822L13.095 6.6982C13.385 6.42277 13.865 6.42277 14.155 6.6982C14.445 6.97363 14.445 7.42951 14.155 7.70495Z"
                                fill="#FF3155"
                              />
                            </svg>
                            <span className="badge-text">RERA</span>
                          </span>
                        </>
                      )}
                    </div>
                    <div className="location">
                      <p>
                        <FontAwesomeIcon icon={faLocationDot} />
                        {propData?.propertyDTO?.propertyLocation
                          ? propData.propertyDTO.propertyLocation
                          : "-"}
                        ,{" "}
                        {propData?.propertyDTO?.city
                          ? propData.propertyDTO.city
                          : "Bangalore"}
                      </p>
                      <Link
                        to={`https://wa.me/?text=${encodeURIComponent(
                          `http://maps.google.com/?q=${propData?.propertyDTO?.propertyLat},${propData?.propertyDTO?.propertyLong}`,
                        )}`}
                        target="_blank"
                      >
                        <span>-</span>Get Direction
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="right-col buy-property-prices-wrap">
                  <div className="right-content">
                    <div className="buy-property-prices-btn">
                      {propData?.propertyDTO?.constructionStatus ? (
                        propData.propertyDTO.constructionStatus.toLowerCase() ===
                        "under construction" ? (
                          <span className="btn-primary ready-to-move-btn under-construction-tag">
                            <FontAwesomeIcon icon={faPersonDigging} />
                            Under Construction
                          </span>
                        ) : propData.propertyDTO.constructionStatus.toLowerCase() ===
                          "ready to move" ? (
                          <button className="btn-primary ready-to-move-btn">
                            Ready to Move
                          </button>
                        ) : null
                      ) : null}
                    </div>
                    <div className="buy-property-info-wrap">
                      <span className="posted-date">
                        Posted on{" "}
                        {propData?.propertyDTO?.addedOn
                          ? formatDatetoMonth(propData.propertyDTO.addedOn)
                          : "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="buy-property-detail-section residency-details-section"
        style={{ backgroundColor: "#f1f5f8" }}
      >
        <div className="container">
          <div className="residency-details-wrap">
            <div className="left-col">
              {/* property images block */}
              <LightGallery
                plugins={[lgZoom, lgVideo]}
                dynamic={true}
                dynamicEl={galleryconfig}
                mobileSettings={{
                  controls: false,
                  download: false,
                  rotate: false,
                }}
                elementClassNames="gallery-container"
                onInit={onInit}
              >
                <div className="property-images">
                  {!isMobile ? (
                    <>
                      <div
                        className="row main-img gallery-item"
                        data-src={galleryItems[0]?.src}
                        onClick={() => openMainGallery(0)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="col-12">
                          <div className="main-property-img">
                            {galleryItems[0]?.type === "Video" ? (
                              <>
                                <img
                                  src={videoThumbnail}
                                  alt={galleryItems[0]?.alt}
                                />
                                <div className="play-button">
                                  <img src="/play-button.png" alt="play" />
                                </div>
                              </>
                            ) : (
                              <img
                                src={galleryItems[0]?.src}
                                alt={galleryItems[0]?.alt}
                              />
                            )}
                            {galleryImages.length > 0 ? (
                              <span className="img-count right-0">
                                {galleryItems.length} Photos{" "}
                                {galleryItems.filter((i) => i.type === "Video")
                                  .length > 0
                                  ? ` • ${galleryItems.filter((i) => i.type === "Video").length} Videos`
                                  : ""}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row sub-images">
                        {galleryItems.slice(1, 5).map((item, index) => {
                          const subImageCount = Math.min(
                            galleryItems.length - 1,
                            4,
                          );
                          const colClass =
                            subImageCount <= 2 ? "col-6" : "col-3";
                          return (
                            <div
                              key={index}
                              className={`${colClass} gallery-item`}
                              data-src={item.src}
                              onClick={() =>
                                openMainGallery(index + 1)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <div className="sub-imgs">
                                {item.type === "Video" ? (
                                  <>
                                    <img src={videoThumbnail} alt={item.alt} />
                                    <div className="play-button">
                                      <img src="/play-button.png" alt="play" />
                                    </div>
                                  </>
                                ) : (
                                  <img src={item.src} alt={item.alt} />
                                )}
                              </div>
                            </div>
                          );
                        })}
                        {galleryItems.length > 5 && (
                          <span
                            className="img-count mb-1"
                            onClick={() => openMainGallery(5)}
                            style={{ cursor: "pointer" }}
                          >
                            +{galleryItems.length - 5} More
                          </span>
                        )}
                      </div>
                    </>
                  ) : (
                    <Swiper
                      modules={[Pagination]}
                      spaceBetween={10}
                      slidesPerView={1}
                      speed={1500}
                      pagination={{ clickable: true }}
                    >
                      {galleryItems.map((item, index) => (
                        <SwiperSlide
                          key={index}
                          data-src={item.src}
                          onClick={() => openMainGallery(index)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="gallery-swriper-item">
                            {item.type === "Video" ? (
                              <>
                                <img src={videoThumbnail} alt={item.alt} />
                                <div className="play-button">
                                  <img src="/play-button.png" alt="play" />
                                </div>
                              </>
                            ) : (
                              <img src={item.src} alt={item.alt} />
                            )}
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )}
                </div>
              </LightGallery>
              {/* End of property images block */}

              {/* property meta details block */}
              <BuyMetaDetails
                bhkdata={bhkdata}
                activeBhk={activeBhk}
                formatAmount={formatAmount}
                propData={propData}
                activeFloorDetail={activeFloorDetail}
              />
              {/* End of property meta details block */}

              {/* Property overview block */}
              <BuyOverview
                isReadMore={isReadMore}
                propData={propData}
                contentRef={contentRef}
                visibleReadmore={visibleReadmore}
                setIsReadMore={setIsReadMore}
              />
              {/* End of Property Overview block */}

              {/* Property details + Floor Plan — one shared tab control */}
              <BuyDetails
                propData={propData}
                bhkdata={bhkdata}
                activeBhk={activeBhk}
                activeFloorDetail={activeFloorDetail}
                onBhkChange={handleBhkChange}
                onFloorChange={handleFloorChange}
              >
                {floorPlanBlock}
              </BuyDetails>
              {/* End of property details section */}

              {/* Property Documentation section */}
              <BuyDocumentation
                documentationData={documentationData}
                formatKeyName={formatKeyName}
              />
              {/* End of Property Documentation section */}

              {/* Amenities section */}
              <BuyAmenities PropertyAmenities={PropertyAmenities} />
              {/* End of Amenities section */}

              {/* Explore nearby block */}
              <BuyNearby
                propertyNearby={propertyNearby}
                exploreNearBy={exploreNearBy}
              />
              {/* End of explore nearby block */}

              {/* Location map block */}
              <BuyLocation propData={propData} />
              {/* End of location map block */}
            </div>

            <div className="right-col" id="book-now">
              <div
                style={{
                  position: "sticky",
                  top: "100px",
                  alignSelf: "flex-start",
                  transition: "transform 0.2s ease-out",
                }}
              >
                {/* Price and other info block */}
                <BuyPriceBlock
                  handleWishlist={handleWishlist}
                  isWishlisted={isWishlisted}
                  user={user}
                  propData={propData}
                  bhkdata={bhkdata}
                  activeBhk={activeBhk}
                  activeFloorDetail={activeFloorDetail}
                  scrollToSchedule={scrollToSchedule}
                />
                {/* End of price block */}

                <div id="Schedule-visit">
                  <ScheduleMeeting
                    busy="New-String"
                    vitualVisit={propertyVideos}
                    schelduleData={schelduleData}
                    fromPage="buy-module"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BuyPropertyDetail;